import { useCallback } from "react";
import { useNativeHealthSDK, PlatformType } from "@/hooks/useNativeHealthSDK";
import { REQUIRED_SDK_DATA_TYPES } from "@/health/healthDataTypes";

export function useLifestyleHealthSDK() {
  const {
    status,
    isConnected,
    hasAnyPermissions,
    isAvailable,
    permissions,
    isLoading,
    error,
    records,
    isFetching,
    requestPermissions,
    fetchHealthData,
    refreshStatus,
    getRecordsByType,
    getLatestRecord,
  } = useNativeHealthSDK();

  const resolvedIsAndroid =
    !!status && status.platform === PlatformType.HEALTH_CONNECT;

  const resolvedIsIOS = !!status && status.platform === PlatformType.HEALTHKIT;

  const handleConnect = useCallback(() => {
    requestPermissions([...REQUIRED_SDK_DATA_TYPES]);
  }, [requestPermissions]);

  const handleFetchData = useCallback(() => {
    fetchHealthData({
      dataTypes: [...REQUIRED_SDK_DATA_TYPES],
      startDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
      endDate: new Date(),
      limit: 100,
    });
  }, [fetchHealthData]);

  return {
    // Platform state
    isConnected,
    hasAnyPermissions,
    isAvailable,
    permissions,
    isLoading,
    error,
    resolvedIsAndroid,
    resolvedIsIOS,
    // Data state
    records,
    isFetching,
    // Actions
    handleConnect,
    handleFetchData,
    refreshStatus,
    // Helpers
    getRecordsByType,
    getLatestRecord,
  };
}

export default useLifestyleHealthSDK;
